import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import moment, { Moment } from 'moment';
import { CoordinatorCompany } from '../../entities/coordinator-company';
import { VisitaEmpresa, VisitaEmpresaSaveModel } from '../../entities/visita-empresa';
import { CoordinatorCompanyService } from '../../services/coordinator-company.service';
import { AddEditVisitaEmpresaComponent } from './add-edit-visita-empresa/add-edit-visita-empresa.component';

@Component({
    selector: 'app-coordinator-company',
    templateUrl: './coordinator-company.component.html',
    styleUrls: ['./coordinator-company.component.scss'],
    standalone: false
})
export class CoordinatorCompanyComponent implements OnInit {

  public isLoading = false;
  public selectedDate: Moment;
  public companyList = new Array<CoordinatorCompany>();
  public companyVisitList = new Array<VisitaEmpresa>();
  public selectedDetails=new VisitaEmpresaSaveModel();

  public selectedVisitId = 0;
  public responsiveOptions: any;
  matToolTip:string="";

  constructor(
    private coordinatorCompanyService: CoordinatorCompanyService,
    private sharedService: SharedService,
    private dialog: MatDialog) {
    this.responsiveOptions = [
      {
        breakpoint: '1920px',
        numVisible: 8,
        numScroll: 1
      },
      {
        breakpoint: '1810px',
        numVisible: 7,
        numScroll: 1
      },
      {
        breakpoint: '1550px',
        numVisible: 6,
        numScroll: 1
      },
      {
        breakpoint: '1366px',
        numVisible: 5,
        numScroll: 1
      }
    ];
  }

  ngOnInit(): void {
    this.selectedDate = moment.utc();
    this.GetCompanyList();
  }

  private GetCompanyList(): void {
    this.isLoading = true;
    const dateString = DateHelper.getUTCDateString(DateHelper.getNativeDate(this.selectedDate));
    this.coordinatorCompanyService.GetCompanyList(dateString).subscribe(res => {
      if (res.code === 0) {
        this.companyList = res.result;
        this.GetCompanyVisits();
      } else {
        this.isLoading = false;
        this.sharedService.ShowSnackBar('No pudo cargar las empresas del coordinador.');
      }
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  private GetCompanyVisits(): void {
    const selectedYear = this.selectedDate.get('year');
    this.coordinatorCompanyService.GetVisitaEmpresa(selectedYear.toString()).subscribe(res => {
      if (res.code === 0) {
        this.companyVisitList = res.result;
      } else {
        this.sharedService.ShowSnackBar('No se pudieron cargar las visitas a la empresa.');
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public onDeleteVisita(selectedId: number): void {
    const message = '¿Eliminar la visita del coordinador?';
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.isLoading = true;
        this.coordinatorCompanyService.DeleteVisitaEmpresa(selectedId.toString()).subscribe(res => {
          if (res.code === 0 && res.result) {
            this.GetCompanyList();
            this.sharedService.ShowSnackBar('Eliminado con éxito la visita a la empresa.');
          } else {
            this.sharedService.ShowSnackBar('No se pudo borrar la visita a la empresa.');
          }
          this.isLoading = false;
        }, error => {
          this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
          this.isLoading = false;
        });
      }
    });
  }

  public openAddEditPopup(isEdit: boolean, company: CoordinatorCompany): void {
    const modalRef = this.dialog.open(AddEditVisitaEmpresaComponent, {
      width: '600px',
    });

    modalRef.componentInstance.saveModel = this.mapVisitaDetailsToSaveModel(isEdit, company);

    modalRef.afterClosed().subscribe(isSaved => {
      if (isSaved) {
        this.GetCompanyList();
      }
    });
  }

  private mapVisitaDetailsToSaveModel(isEdit: boolean, company: CoordinatorCompany): VisitaEmpresaSaveModel {
    const saveModel = new VisitaEmpresaSaveModel();
    saveModel.CompanyId = company.empresaId;
    if (isEdit) {
      saveModel.Id = company.selectedVisitDetails.id;
      saveModel.Assistant = company.selectedVisitDetails.asistentes;
      saveModel.Concept = company.selectedVisitDetails.asunto;
      saveModel.Description = company.selectedVisitDetails.resumen;
      saveModel.Type = company.selectedVisitDetails.tipo;
      saveModel.PlannedDate = company.selectedVisitDetails.fplanificacion;
      saveModel.DoneDate = company.selectedVisitDetails.frealizacion;
      saveModel.AsistentesEmpresa = company.selectedVisitDetails.asistentesEmpresa;
      saveModel.AsistentesMutua = company.selectedVisitDetails.asistentesMutua;
      saveModel.Comentarios = company.selectedVisitDetails.comentarios;
    }
    return saveModel;
  }

  public yearChanged(selectedDate: Moment) {
    this.selectedDate = selectedDate;
    this.GetCompanyList();
  }

  public toggleDetails(company: CoordinatorCompany, visitaEmpresaId): void {
    this.matToolTip="";
    company.showVisit = company.selectedVisitaId !== visitaEmpresaId ? true : !company.showVisit;
    company.selectedVisitDetails = null;
    company.selectedVisitaId = null;
    if (company.showVisit) {
      company.selectedVisitaId = visitaEmpresaId;
      this.coordinatorCompanyService.GetVisitaEmpresaDetails(visitaEmpresaId.toString()).subscribe(res => {
        if (res.code === 0) {
          const selected = this.companyList.filter(e => e.id === company.id)[0];
          const selectedIndex = this.companyList.indexOf(selected);
          selected.selectedVisitDetails = res.result;
          this.companyList.splice(selectedIndex, 1, selected);
          if(selected.selectedVisitDetails.asistentes){
            this.matToolTip+="Asistentes: "+selected.selectedVisitDetails.asistentes+" "
          }
          if(selected.selectedVisitDetails.asistentesEmpresa){
            this.matToolTip+="Asistentes de la Empresa: "+selected.selectedVisitDetails.asistentesEmpresa+" "
          }
          if(selected.selectedVisitDetails.asistentesMutua){
            this.matToolTip+="Asistentes de la Mutua: "+selected.selectedVisitDetails.asistentesMutua+" "
          }
        } else {
          this.sharedService.ShowSnackBar('No se pudieron cargar los detalles de la visita.');
        }
      }, error => {
        console.log(error);
        this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
      });
    }
  }

}
